exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dialog .el-row[data-v-3b24eb5c] {\n  border-bottom: 1px solid #EBEEF5;\n}\n", ""]);

// exports
